import { zodToSchema } from '@walkeros/core';
import { SettingsSchema } from './settings';
import { MappingSchema } from './mapping';

export { SettingsSchema, type Settings } from './settings';
export { MappingSchema, type Mapping } from './mapping';

// JSON Schema
export const settings = zodToSchema(SettingsSchema);
export const mapping = zodToSchema(MappingSchema);
